module.exports = __webpack_public_path__ + "static/media/17_thestar.227cf350.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/17_thestar.png
// module id = 80
// module chunks = 0